import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const WizardHeaderTop = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
});

export const WizardStepCounter = styled(Typography)({
  fontSize: '14px',
  color: 'var(--am-text-secondary)',
  whiteSpace: 'nowrap',
}) as typeof Typography;

export const WizardProgressRow = styled(Box)({
  display: 'flex',
  gap: 4,
  marginTop: 12,
});

export const WizardProgressSegment = styled(Box, {
  shouldForwardProp: (prop) => prop !== '$active',
})<{ $active: boolean }>(({ $active }) => ({
  flex: 1,
  height: 3,
  borderRadius: 2,
  background: $active ? 'var(--am-icon-accent)' : 'var(--am-surface-2)',
  transition: 'background 0.2s',
}));
